import React, { useState, useEffect } from 'react';
import Layout from '../components/layout/Layout';
import GlobalDistributionDonut from '../components/dashboard/GlobalDistributionDonut';
import MonthlyInsectsBar from '../components/dashboard/MonthlyInsectsBar';
import SpeciesYearlyBar from '../components/dashboard/SpeciesYearlyBar';
import { dashboardAPI } from '../services/api';
import {
  transformGlobalDistribution,
  transformMonthlyInsects,
  transformYearlySpecies
} from '../utils/dataTransformers';
import '../components/dashboard/Dashboard.css';

export default function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    global: { total: 0, distribution: [] },
    monthly: [],
    yearly: []
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const [globalRes, monthlyRes, yearlyRes] = await Promise.all([
          dashboardAPI.getGlobalDistribution(),
          dashboardAPI.getMonthlyInsects(),
          dashboardAPI.getYearlySpecies()
        ]);

        setData({
          global: transformGlobalDistribution(globalRes.data),
          monthly: transformMonthlyInsects(monthlyRes.data),
          yearly: transformYearlySpecies(yearlyRes.data)
        });
      } catch (err) {
        console.error('Error fetching dashboard data:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (loading) return <Layout><div>Loading...</div></Layout>;

  return (
    <Layout>
      <div className="dash-grid">
        <section className="panel panel-1">
          <GlobalDistributionDonut data={data.global} />
        </section>
        <section className="panel panel-2">
          <MonthlyInsectsBar data={data.monthly} />
        </section>
        <section className="panel panel-3">
          <SpeciesYearlyBar data={data.yearly} />
        </section>
      </div>
    </Layout>
  );
}